import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import { useEffect } from "react";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function DefineScenarioSettings() {
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.editScenarioNew);
  const { minimumQuota, editScDetails, criticalityList, criticalityId, zeroMs } =
    setupState;

  useEffect(() => {
    if (editScDetails !== null) {
      // dispatch(setState("minimumQuota", editScDetails.minimumQuota));
      // dispatch(setState("skuBreakdown", editScDetails.skuBreakdown));
      // dispatch(setState("selectedScSTQ", "Enabled"));
      dispatch(setState("zeroMs", editScDetails.zeroMs === "Y" ? true : false));
    }
  }, [editScDetails]);

  const handleStateUpdate = (event, stateName) => {
    const value = event.target.value;
    dispatch(setState(stateName, value));
  };

  const handleCheckedUpdate = (event, stateName) => {
    const option = event.target.checked;
    dispatch(setState(stateName, option));
  };

  return (
    <Box sx={{ mt: 4 }}>
      {/* <hr style={{
     border: ".25px solid #c6c6c6",
    }}/> */}
      {/* <Typography sx={{ color: "lightBlue.main", fontWeight: "700", marginBottom: 2, mt: 3, }} className="compHeading">
					Define Scenario Settings
				</Typography> */}

      <Box sx={{ mt: 4 }}>
        <Grid container spacing={2} columns={12} alignContent={"space-between"}>
          <Grid item sm={4} md={4} xs={4} lg={4}>
            <Box>
              <TextField
                sx={{
                  width: "100%",
                }}
                type={"number"}
                id="outlined-basic"
                label="Minimum Quota Value"
                variant="outlined"
                size="small"
                value={minimumQuota}
                onChange={(event) => {
                  const inputValue = parseFloat(event.target.value);
                  if (isNaN(inputValue) || inputValue >= 0) {
                    handleStateUpdate(event, "minimumQuota");
                  }
                }}
                InputProps={{ autoComplete: "off" }}
              />
            </Box>
          </Grid>

          <Grid item sm={3} md={3} xs={3} lg={3}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                mt: 0,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={zeroMs}
                    onChange={(event) => handleCheckedUpdate(event, "zeroMs")}
                    InputProps={{ "aria-label": "controlled" }}
                  />
                }
              />

              <Typography
                variant="subtitle2"
                sx={{ mt: 1.5, ml: -2, fontSize: 14 }}
              >
                Include 0% MS
              </Typography>
            </Box>
          </Grid>

          <Grid item sm={5} md={5} xs={5} lg={5}>
            <Box>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Scenario Criticality
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={criticalityId}
                  label="Scenario Criticality"
                  sx={{
                    height: commonHeight,
                    width: SW,
                    color: "black.main",
                    mt: 1,
                  }}
                  onChange={(event) =>
                    handleStateUpdate(event, "criticalityId")
                  }
                >
                  {criticalityList?.map((source, index) => {
                    return (
                      <MenuItem
                        key={index}
                        value={source.scenarioCriticalityID}
                      >
                        {source.scenarioCriticalityDesc}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* <Grid item sm={6} md={3} lg={3}>
						<Box>
							<FormControl sx={{width: "100%",}}>
								<InputLabel id="demo-simple-select-label">
									Scenario Stick to Quota
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedScSTQ}
									label="Scenario Stick to Quota"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={(event) =>
										handleStateUpdate(event, "selectedScSTQ")
									}
								>
									{scenarioSTQ.map((item, index) => {
										return (
											<MenuItem key={index} value={item.value}>
												{item.value}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid> */}
        </Grid>
      </Box>
    </Box>
  );
}
